module.exports = __webpack_public_path__ + "img/notviewicon.caf0daf9.svg";